module.exports = __webpack_public_path__ + "img/communitasAmerica.9340a833.png";